const toggleTipContainer = "_toggleTipContainer_9azzt_1";
const toggletipButton = "_toggletipButton_9azzt_7";
const toggletipTrigger = "_toggletipTrigger_9azzt_26";
const toggletipIcon = "_toggletipIcon_9azzt_65";
const toggletipIconHidden = "_toggletipIconHidden_9azzt_76";
const toggletipPopover = "_toggletipPopover_9azzt_82";
const toggletipArrow = "_toggletipArrow_9azzt_96";
const styles = {
  toggleTipContainer,
  toggletipButton,
  toggletipTrigger,
  "toggletip-default-icon": "_toggletip-default-icon_9azzt_44",
  "toggletip-inverted-icon": "_toggletip-inverted-icon_9azzt_49",
  "toggletip-default-active": "_toggletip-default-active_9azzt_54",
  "toggletip-inverted-active": "_toggletip-inverted-active_9azzt_58",
  toggletipIcon,
  toggletipIconHidden,
  toggletipPopover,
  toggletipArrow,
  "toggletip-default-text": "_toggletip-default-text_9azzt_110",
  "toggletip-inverted-text": "_toggletip-inverted-text_9azzt_124"
};
export {
  styles as s
};
